import script from "./sortTable.vue?vue&type=script&setup=true&lang=js"
export * from "./sortTable.vue?vue&type=script&setup=true&lang=js"

import "./sortTable.vue?vue&type=style&index=0&id=c7b93d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7b93d38"]])

export default __exports__